import lazySizes from "lazysizes";
lazySizes.cfg.init = false;

import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes/plugins/print/ls.print";
import "lazysizes/plugins/native-loading/ls.native-loading";
import initLazysizesCustom from "./modules/lazysizes-custom";

if (window.maxiaLazyActive === true) {
    document.addEventListener('readystatechange', (event) => {
        if (event.target.readyState === 'complete') {
            document.body.classList.add('maxia-lazy');
        }
    }, false);

    initLazysizesCustom();
    lazySizes.cfg = window.lazySizesConfig;
    lazySizes.init();
}

if (module.hot) {
    module.hot.accept();
}